import { Checkbox, HStack, Text } from '@chakra-ui/react';

type User = {
  id: string;
  email: string;
};

type Props<TData extends User> = {
  userList: TData[];
  disabledUserList?: string[];
  selectedUsersIds: string[];
  onSelectionChangeUser: (userId: string, newState: boolean) => void;
};

export const SelectableUserList = <TData extends User>({
  userList,
  selectedUsersIds,
  onSelectionChangeUser,
  disabledUserList,
}: Props<TData>) => {
  return (
    <>
      {userList.map((item) => {
        const isChecked = selectedUsersIds.includes(item.id);
        const isDisabled = disabledUserList?.includes(item.id);
        return (
          <HStack alignItems="center" justifyContent="left" key={item.id}>
            <Checkbox
              size="lg"
              isChecked={isChecked}
              onChange={(e) => onSelectionChangeUser(item.id, e.target.checked)}
              isDisabled={isDisabled}
            />
            <Text userSelect="none" opacity={isDisabled ? 0.7 : 1}>
              {item.email}{' '}
            </Text>
          </HStack>
        );
      })}
    </>
  );
};
